import moment from 'moment';

export function formatDate(dateInput?: string | Date): string {
  if (!dateInput) return '';

  const date = moment(dateInput);

  if (!date.isValid()) return '';

  return date.local().format('DD/MM/YYYY');
}
